import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatCardModule } from '@angular/material/card'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'
import { AreaChartModule } from '@swimlane/ngx-charts'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { ButtonGroupModule } from '../button-group'
import { ChargesTableFormModule } from '../charges-table-selector'
import { FacilitySelectorModule } from '../facility-selector'
import { ChargesDialogComponent } from './charges-dialog.component'
import { ModelClaimSearchComponent } from './model-claim-search'

@NgModule({
  imports: [
    CommonModule,
    AreaChartModule,
    ButtonGroupModule,
    ChargesTableFormModule,
    DirectivesModule,
    FacilitySelectorModule,
    FlexLayoutModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [ChargesDialogComponent, ModelClaimSearchComponent],
  exports: [ModelClaimSearchComponent],
})
export class ChargesDialogModule {}
